import { FULL_HEART, FULL_HUNGER } from "../tiles";

export const SpellList = [
  {
    id: "draw",
    listed: true,
    name: "Draw",
    description: `Draw a new tile and pass a turn. Does not reduce ${FULL_HUNGER}`,
    ability: "drawOne",
    cost: 1,
    uses: 2,
  },
  {
    id: "exchange",
    listed: true,
    name: "Exchange",
    description: `Swap your tiles for new ones. Costs ${FULL_HUNGER}`,
    ability: "selfTrash",
    cost: 1,
  },
  {
    id: "place",
    listed: true,
    name: "Place Block",
    description: "Discard a letter and place it on the map",
    ability: "placeBlock",
    uses: 4,
    cost: 1,
  },
  {
    id: "telekensis",
    listed: true,
    name: "Telekensis",
    description: `Grabs items from target location.`,
    uses: 3,
    cost: 1,
    ability: {
      target: {
        type: "target",
        distance: 6,
        passableOnly: true,
      },
      effects: [
        {
          pickupAtTarget: true,
        },
      ],
    },
  },
  {
    id: "intimidate",
    listed: true,
    name: "Intimidate",
    description: "Remove a word from your opponent's vocabulary",
    ability: "weaken",
    cost: 1,
    uses: 5,
  },
  {
    id: "strength",
    listed: false,
    name: "Strength",
    description: `Gain 1 Max ${FULL_HEART}`,
    cost: 2,
    onAdded: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [{ stat: "health", type: "max", amount: 1 }],
        },
      ],
    },
  },
  {
    id: "willpower",
    listed: false,
    name: "Willpower",
    description: `Gain 1 Max ${FULL_HUNGER}`,
    cost: 2,
    onAdded: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [{ stat: "hunger", type: "max", amount: 1 }],
        },
      ],
    },
  },
  {
    id: "intelligence",
    listed: false,
    name: "Intelligence",
    description: `+2 max letters in your wand`,
    cost: 2,
    onAdded: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [{ stat: "wand", type: "max", amount: 2 }],
        },
      ],
    },
  },
  {
    id: "sustain",
    listed: true,
    name: "Sustain",
    description: `Discard 3 letters, Gain ${FULL_HUNGER}${FULL_HUNGER}${FULL_HUNGER}`,
    cost: 2,
    uses: 4,
  },
  {
    id: "polymorph",
    listed: true,
    name: "Polymorph",
    description: "Change yourself into a word of the same length",
    ability: "simplePoly",
    uses: 6,
    cost: 2,
  },
  {
    id: "duplicate",
    requires: ["place"],
    listed: true,
    name: "Duplicate",
    description: "Place a duplicate of a letter from your wand",
    uses: 3,
    cost: 2,
    ability: "duplicateBlock",
  },
  {
    id: "scrappy",
    listed: false,
    name: "Scrappy",
    description: `Gain 2 max ${FULL_HEART}, lose 2 max ${FULL_HUNGER}`,
    requires: ["strength"],
    cost: 2,
    onAdded: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [
            { stat: "hunger", type: "max", amount: -2 },
            { stat: "health", type: "max", amount: 2 },
          ],
        },
      ],
    },
  },
  {
    id: "wizened",
    listed: false,
    name: "Wizened",
    description: `Lose ${FULL_HEART}, +2 max letters in your wand`,
    requires: ["intelligence"],
    cost: 2,
    onAdded: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [
            { stat: "wand", type: "max", amount: 2 },
            { stat: "health", type: "max", amount: -1 },
          ],
        },
      ],
    },
  },
  {
    id: "morph",
    listed: true,
    name: "Morph",
    description: "Change a target into a word of the same length",
    ability: "targetPoly",
    uses: 6,
    cost: 2,
  },
  {
    id: "mindblast",
    listed: true,
    name: "Mindblast",
    description: "Remove up to 3 words from your opponent's vocabulary",
    requires: ["exchange", "intimidate"],
    ability: "hinder",
    cost: 2,
    uses: 3,
  },
  {
    id: "bounty",
    name: "Bounty",
    description: `Fill your wand`,
    listed: true,
    cost: 3,
    uses: 2,
    requires: "draw",
    ability: "drawFull",
  },
  {
    id: "cycle",
    name: "Cycle",
    description: `Fill your wand`,
    listed: true,
    cost: 3,
    uses: 3,
    requires: ["draw", "exchange"],
    ability: "cycle",
  },
  {
    id: "endurance",
    name: "Endurance",
    description: `Gain 3 ${FULL_HUNGER}`,
    cost: 6,
    requires: "willpower",
    onAdded: {
      advancesTurn: false,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [{ stat: "hunger", type: "max", amount: 3 }],
        },
      ],
    },
  },
];

export const SpellTypes = SpellList.reduce((r, value) => {
  r[value.id] = value;
  return r;
}, {} as Record<string, any>);
